import Shadow from "../../api/model/snapshots/layers/Shadow";
import { TransformedShadow, TransformedShadowDiff } from "../../model/transform";
import { colorEquals } from "./color";

function equals(shadow: Shadow, otherShadow: Shadow) {
    return (
        shadow.type === otherShadow.type &&
        shadow.offsetX === otherShadow.offsetX &&
        shadow.offsetY === otherShadow.offsetY &&
        shadow.spread === otherShadow.spread &&
        shadow.blurRadius === otherShadow.blurRadius &&
        colorEquals(shadow.color, otherShadow.color)
    );
}

function transformedDiff(shadow: TransformedShadow, otherShadow: TransformedShadow): TransformedShadowDiff {
    const diff: TransformedShadowDiff = {};

    if (shadow.blurRadius !== otherShadow.blurRadius) {
        diff.blurRadius = { change: {
            oldValues: otherShadow.blurRadius,
            newValues: shadow.blurRadius
        } };
    }

    if (shadow.offsetX !== otherShadow.offsetX) {
        diff.offsetX = { change: {
            oldValues: otherShadow.offsetX,
            newValues: shadow.offsetX
        } };
    }

    if (shadow.offsetY !== otherShadow.offsetY) {
        diff.offsetY = { change: {
            oldValues: otherShadow.offsetY,
            newValues: shadow.offsetY
        } };
    }

    if (shadow.spread !== otherShadow.spread) {
        diff.spread = { change: {
            oldValues: otherShadow.spread,
            newValues: shadow.spread
        } };
    }

    if (shadow.type !== otherShadow.type) {
        diff.type = { change: {
            oldValues: otherShadow.type,
            newValues: shadow.type
        } };
    }

    if (!colorEquals(shadow.color.value, otherShadow.color.value)) {
        diff.color = { change: {
            oldValues: otherShadow.color,
            newValues: shadow.color
        } };
    }

    return diff;
}

export { equals, transformedDiff };
